export default {"src":"/_next/static/media/brochure_bg.7a2271e3.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};